/* ============================================================================
   bt-ratgeber-calc.js  ·  Kern fuer die interaktiven Tools

   Zwei Wege, ein Ergebnis:
   1. Handgeschrieben. Das Tool steht als Funktion in bt-minitools.js.
   2. Datengetrieben. Das Tool steht als Metaobjekt bt_tools im Admin und wird
      von BT-R01 als JSON neben den Mount-Punkt gelegt.

   Der Datenweg hat VORRANG. Das Anlegen des Metaobjekts IST der Umschalter.
   Loescht man es, greift wieder der Code.

   DREI BAUSTEINE FUER DIE AUSGABE:
   1. ergebnisse  Genau EINES gewinnt, das erste passende. Die Ueberschrift.
   2. hinweise    ALLE passenden werden gezeigt. Fuer Antworten, die sich aus
                  unabhaengigen Teilen zusammensetzen. Ohne diesen Baustein
                  muesste der Platz-Check 8 Raeume mal 4 Etagen mal 4 Gewichte
                  als 128 einzelne Ergebnisse pflegen.
   3. Platzhalter Im Text ersetzt {{schluessel}} den Wert aus dem Zustand. So
                  koennen Rechenstrategien Zahlen und Aufzaehlungen in einen
                  Text geben, der trotzdem redaktionell pflegbar bleibt.

   FORTSCHRITT: Die Leiste zaehlt BEANTWORTETE Fragen, nicht vorausgewaehlte.
   Jede Frage startet mit einer Vorauswahl, damit sofort ein Ergebnis dasteht.
   Wuerde die Leiste diese mitzaehlen, waere sie von Anfang an voll und damit
   wertlos. Erst ein Klick markiert die Frage als beantwortet.

   ACHTUNG beim Bearbeiten ueber die Admin-API: niemals typografische
   Anfuehrungszeichen im Dateiinhalt verwenden, der Upload bricht sonst ab.
   ========================================================================== */
(function(){
  'use strict';
  var BT = window.BTModul = window.BTModul || { reg: {} };

  BT.track = BT.track || function(phase, tool, params){
    window.dataLayer = window.dataLayer || [];
    var e = { event: 'minitool_' + phase, tool: tool };
    if(params){ for(var k in params){ if(Object.prototype.hasOwnProperty.call(params, k)) e[k] = params[k]; } }
    window.dataLayer.push(e);
  };


  /* ---- Kopfzeile und Fortschritt ---------------------------------------- */

  BT.dress = BT.dress || function(slot){
    var fragen = slot.querySelectorAll('.bt-calc__q').length;
    if(!fragen) return;

    var eyebrow = slot.querySelector('.bt-calc__head .bt-eyebrow');
    if(eyebrow){
      eyebrow.textContent = fragen === 1 ? btT('bt_ratgeber_calc.questions_one', 'In einer Frage') : btT('bt_ratgeber_calc.questions_other', 'In {n} Fragen', {n: fragen});
    }

    var head = slot.querySelector('.bt-calc__head');
    if(!head) return;

    var bar = slot.querySelector('.bt-calc__steps');
    if(bar && bar.children.length === fragen) return;
    if(bar) bar.parentNode.removeChild(bar);
    if(fragen < 2) return;

    bar = document.createElement('div');
    bar.className = 'bt-calc__steps';
    for(var i = 0; i < fragen; i++){
      var s = document.createElement('i');
      s.className = 'bt-calc__step';
      bar.appendChild(s);
    }
    head.parentNode.insertBefore(bar, head.nextSibling);
  };

  BT.progress = BT.progress || function(slot){
    var qs = slot.querySelectorAll('.bt-calc__q');
    var steps = slot.querySelectorAll('.bt-calc__step');
    for(var i = 0; i < steps.length; i++){
      var q = qs[i];
      steps[i].classList.toggle('is-done', !!(q && q.getAttribute('data-beantwortet')));
    }
  };

  function markiere(ev){
    var b = ev.target.closest ? ev.target.closest('.bt-calc__opt') : null;
    if(!b) return null;
    var q = b.closest('.bt-calc__q');
    if(q) q.setAttribute('data-beantwortet', '1');
    return b;
  }


  /* ======================= DATENGETRIEBENER RENDERER ======================= */

  /* Rechenstrategien bekommen den Zustand und geben zusaetzliche Fakten
     zurueck. Genau hier liegt die Grenze zwischen Daten und Code: Redaktion
     steuert jedes Wort und jeden Link, Entwicklung die Rechnerei. Registriert
     werden sie dort, wo die Datenbasis liegt, also in bt-minitools.js. */
  BT.strategien = BT.strategien || {};

  /* Bedingungen. Vier Formen:
       {}                          immer
       {"inhalt":"papier"}         gleich
       {"etage":["oben","dach"]}   einer von mehreren
       {"summe":{"bis":65000}}     Zahlenbereich, auch ab, auch beides */
  function passt(bedingung, zustand){
    if(!bedingung) return true;
    for(var k in bedingung){
      if(!Object.prototype.hasOwnProperty.call(bedingung, k)) continue;
      var soll = bedingung[k], ist = zustand[k];

      if(Object.prototype.toString.call(soll) === '[object Array]'){
        if(soll.indexOf(ist) < 0) return false;
      } else if(soll && typeof soll === 'object'){
        var z = parseFloat(ist);
        if(isNaN(z)) return false;
        if(typeof soll.bis === 'number' && z > soll.bis) return false;
        if(typeof soll.ab === 'number' && z < soll.ab) return false;
      } else if(soll !== ist){
        return false;
      }
    }
    return true;
  }

  function esc(s){
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  /* Mehrsprachigkeit (30.09.2026): Zahlenformat folgt der Sprache. */
  function zahl(v){ return Number(v).toLocaleString(document.documentElement.lang || 'de'); }

  /* Interne Ziele (/collections/…, /pages/…) aus dem Metaobjekt bekommen das
     Sprach-/Marktpraefix (z. B. /fr/), bereits praefixierte bleiben, wie sie sind. */
  function lurl(h){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if(!h || root === '/' || h.charAt(0) !== '/' || h.charAt(1) === '/' || h.indexOf(root) === 0) return h;
    return root + h.slice(1);
  }

  /* Platzhalter im Text: {{schluessel}} wird durch den Wert aus dem Zustand
     ersetzt. Unbekannte Schluessel werden entfernt statt stehen gelassen,
     damit im Shop nie geschweifte Klammern auftauchen. */
  function fuell(s, z){
    if(s == null) return '';
    return String(s).replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function(_, k){
      return z[k] == null ? '' : String(z[k]);
    });
  }

  BT.datenTool = function(slot, cfg){
    /* wahl je Frage:
         einfachauswahl   Index der gewaehlten Antwort
         mehrfachauswahl  Objekt mit Index als Schluessel
         betrag           Zahl */
    var wahl = {};

    function faktenAusFrage(f, z){
      var antworten = f.antworten || [];

      if(f.typ === 'betrag'){
        var v = wahl[f.schluessel];
        if(typeof v === 'number' && !isNaN(v)) z[f.schluessel] = v;
        return;
      }

      if(f.typ === 'mehrfachauswahl'){
        var sel = wahl[f.schluessel] || {};
        antworten.forEach(function(a, i){
          if(!sel[i] || !a.werte) return;
          for(var k in a.werte) z[k] = a.werte[k];
        });
        return;
      }

      var idx = wahl[f.schluessel];
      if(typeof idx !== 'number' || !antworten[idx]) idx = 0;
      var a = antworten[idx];
      if(a && a.werte){ for(var k2 in a.werte) z[k2] = a.werte[k2]; }
    }

    /* Sichtbare Fragen und Zustand in EINEM Durchlauf, damit die Bedingung
       eines Schritts die Antworten der vorherigen sieht. Ein spaeterer Schritt
       kann sich auf einen frueheren beziehen, nie umgekehrt. Zyklenfrei. */
    function lauf(){
      var fragen = [], z = {};
      (cfg.schritte || []).forEach(function(f){
        if(!passt(f.bedingung, z)) return;
        fragen.push(f);
        faktenAusFrage(f, z);
      });

      var strat = BT.strategien[cfg.auswertung];
      if(strat){
        var zusatz = strat(z) || {};
        for(var k in zusatz){ if(Object.prototype.hasOwnProperty.call(zusatz, k)) z[k] = zusatz[k]; }
      }
      return { fragen: fragen, zustand: z };
    }

    function optionenHtml(f){
      var antworten = f.antworten || [];

      if(f.typ === 'betrag'){
        var v = wahl[f.schluessel];
        return '<div class="bt-calc__custom">'
          + '<span class="bt-calc__inputwrap">'
          + '<input type="text" inputmode="numeric" autocomplete="off" placeholder="' + esc(zahl(85000)) + '"'
          + ' value="' + (typeof v === 'number' ? esc(zahl(v)) : '') + '"'
          + ' data-betrag="' + esc(f.schluessel) + '"><span>€</span></span></div>';
      }

      var mehrfach = f.typ === 'mehrfachauswahl';
      return '<div class="bt-calc__opts">' + antworten.map(function(a, i){
        var aktiv = mehrfach
          ? !!(wahl[f.schluessel] || {})[i]
          : (typeof wahl[f.schluessel] === 'number' ? wahl[f.schluessel] : 0) === i;
        return '<button type="button" class="bt-calc__opt' + (aktiv ? ' is-active' : '') + '"'
          + ' data-f="' + esc(f.schluessel) + '" data-i="' + i + '"'
          + ' aria-pressed="' + (aktiv ? 'true' : 'false') + '">'
          + esc(a.label) + (a.zusatz ? '<small>' + esc(a.zusatz) + '</small>' : '') + '</button>';
      }).join('') + '</div>';
    }

    function fragenHtml(fragen){
      return fragen.map(function(f, nr){
        var beantwortet = Object.prototype.hasOwnProperty.call(wahl, f.schluessel);
        return '<div class="bt-calc__q" data-q="' + esc(f.schluessel) + '"'
          + (beantwortet ? ' data-beantwortet="1"' : '') + '>'
          + '<div class="bt-calc__qlabel">' + (nr + 1) + ' · ' + esc(f.text)
          + (f.hilfe ? ' <span class="bt-calc__qhint">' + esc(f.hilfe) + '</span>' : '')
          + '</div>' + optionenHtml(f) + '</div>';
      }).join('');
    }

    function ausgabeHtml(z){
      var liste = cfg.ergebnisse || [];
      var treffer = null;
      for(var i = 0; i < liste.length; i++){
        if(passt(liste[i].bedingung, z)){ treffer = liste[i]; break; }
      }

      if(!treffer){
        if(window.Shopify && window.Shopify.designMode){
          return '<div class="bt-calc__note"><b>Kein Ergebnis passt</b> Dieser Kombination ist kein Ergebnis zugeordnet. '
            + 'Im Metaobjekt BT Tool muss das letzte Ergebnis die leere Bedingung tragen.</div>';
        }
        return '';
      }

      var h = '<div class="bt-calc__reyebrow">' + esc(treffer.eyebrow || btT('bt_ratgeber_calc.your_recommendation', 'Ihre Empfehlung')) + '</div>'
        + '<div class="bt-calc__grade">' + fuell(esc(treffer.titel), z) + '</div>';
      if(treffer.text) h += '<div class="bt-calc__note">' + fuell(treffer.text, z) + '</div>';
      if(treffer.hinweis) h += '<div class="bt-calc__note">' + fuell(treffer.hinweis, z) + '</div>';

      /* Additive Bausteine: ALLE passenden, in ihrer Reihenfolge. */
      (cfg.hinweise || []).forEach(function(x){
        if(!x || !x.text) return;
        if(!passt(x.bedingung, z)) return;
        h += '<div class="bt-calc__note">' + fuell(x.text, z) + '</div>';
      });

      var btns = '';
      ['cta1','cta2','cta3'].forEach(function(k){
        var c = treffer[k];
        if(c && c.ziel) btns += '<a class="bt-btn' + (k === 'cta1' ? '' : ' bt-btn--ghost') + '" href="' + esc(lurl(c.ziel)) + '">' + esc(c.label) + '</a>';
      });
      if(btns) h += '<div class="bt-minitool__ctas">' + btns + '</div>';

      return { html: h, titel: treffer.titel };
    }

    slot.innerHTML = '<div class="bt-calc" data-bt-calc>'
      + '<div class="bt-calc__head"><div class="bt-eyebrow"></div><h2>' + esc(cfg.titel) + '</h2>'
      + (cfg.einleitung ? '<p>' + esc(cfg.einleitung) + '</p>' : '') + '</div>'
      + (cfg.vorspann_html || '')
      + '<div data-bt-fragen></div>'
      + '<div class="bt-calc__result bt-calc__result--live" data-bt-result aria-live="polite"></div></div>';

    var root = slot.querySelector('[data-bt-calc]');
    var wrapFragen = root.querySelector('[data-bt-fragen]');
    var out = root.querySelector('[data-bt-result]');

    function zeichneErgebnis(z){
      var a = ausgabeHtml(z);
      if(typeof a === 'string'){ out.innerHTML = a; return; }
      out.innerHTML = a.html;
      BT.track('completed', cfg.schluessel, {ergebnis: a.titel});
    }

    function render(){
      var r = lauf();
      wrapFragen.innerHTML = fragenHtml(r.fragen);
      zeichneErgebnis(r.zustand);
      BT.dress(slot);
      BT.progress(slot);
    }

    root.addEventListener('click', function(ev){
      var b = markiere(ev);
      if(!b || !root.contains(b)) return;
      var f = b.getAttribute('data-f');
      if(!f) return;
      var i = parseInt(b.getAttribute('data-i'), 10) || 0;

      var frage = null;
      (cfg.schritte || []).forEach(function(x){ if(x.schluessel === f) frage = x; });

      if(frage && frage.typ === 'mehrfachauswahl'){
        wahl[f] = wahl[f] || {};
        wahl[f][i] = !wahl[f][i];
      } else {
        wahl[f] = i;
      }
      BT.track('answered', cfg.schluessel, {frage: f, antwort: i});
      render();
    });

    /* Beim Tippen NUR das Ergebnis neu zeichnen, sonst verliert das
       Eingabefeld mitten im Tippen den Fokus. */
    root.addEventListener('input', function(ev){
      var el = ev.target;
      if(!el || !el.getAttribute || !el.getAttribute('data-betrag')) return;
      var f = el.getAttribute('data-betrag');
      var digits = String(el.value).replace(/[^0-9]/g, '');
      if(!digits){ delete wahl[f]; } else { wahl[f] = parseInt(digits, 10); }
      var q = el.closest('.bt-calc__q');
      if(q) q.setAttribute('data-beantwortet', '1');
      zeichneErgebnis(lauf().zustand);
      BT.progress(slot);
      if(digits) el.value = zahl(parseInt(digits, 10));
    });

    render();
  };


  /* ---- Initialisierung ---------------------------------------------------- */
  BT.init = BT.init || function(scope){
    var slots = (scope || document).querySelectorAll('[data-bt-modul]');
    Array.prototype.forEach.call(slots, function(slot, i){
      if(slot.dataset.btDone) return;
      var typ = slot.getAttribute('data-bt-modul');
      if(!typ) return;

      var cfgEl = document.querySelector('[data-bt-config="' + typ + '"]');
      if(cfgEl){
        var cfg = null;
        try { cfg = JSON.parse(cfgEl.textContent); } catch(err){ cfg = null; }
        if(cfg && cfg.schritte && cfg.schritte.length){
          slot.dataset.btDone = '1';
          slot.setAttribute('data-bt-minitool', typ);
          BT.datenTool(slot, cfg);
          BT.track('started', typ, {quelle:'metaobjekt'});
          return;
        }
      }

      var fn = BT.reg[typ];
      if(!fn) return;
      slot.dataset.btDone = '1';
      slot.setAttribute('data-bt-minitool', typ);
      fn(slot, 'bt' + typ.replace(/[^a-z0-9]/gi, '') + i);

      BT.dress(slot);
      BT.progress(slot);

      slot.addEventListener('click', function(ev){
        markiere(ev);
        setTimeout(function(){ BT.dress(slot); BT.progress(slot); }, 0);
      });

      BT.track('started', typ, {quelle:'code'});
    });
  };

  BT.warn = BT.warn || function(){
    if(BT.pending) return;
    if(!(window.Shopify && window.Shopify.designMode)) return;
    document.querySelectorAll('[data-bt-modul]').forEach(function(slot){
      if(slot.dataset.btDone) return;
      var t = document.createElement('div');
      t.textContent = slot.getAttribute('data-bt-modul') || '';
      slot.innerHTML = '<div class="bt-infobox bt-infobox--warnung"><div class="bt-infobox__icon">!</div><div><b>Unbekanntes Modul</b>Der Wert ' + t.innerHTML + ' ist weder im Code registriert noch als Metaobjekt BT Tool angelegt.</div></div>';
    });
  };

  function boot(){ BT.init(); setTimeout(BT.warn, 1200); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', function(e){ BT.init(e.target); });
})();